"use client";

import React, { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button when page is scrolled down 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    // Check initial scroll position
    toggleVisibility();

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed right-[30px] bottom-[30px] w-[45px] h-[45px] z-[1000] flex items-center justify-center rounded-[3px] text-white transition-all duration-[700ms] shadow-md
        ${isVisible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-[30px] pointer-events-none"}
        bg-[#c59d5f] hover:bg-[#282828]`}
      aria-label="Back to top"
    >
      <ChevronUp size={24} strokeWidth={2.5} />
    </button>
  );
};

export default BackToTop;
